import { useTheme } from "../../../../components/hooks/useTheme";
import { FleetGeneralSettings } from "./FleetGeneralSettings";

export const FleetSettings = () => {
  const { themeStyles } = useTheme();

  return (
    <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
      <div className={`w-full ${themeStyles.main.tailwindMainBg} border ${themeStyles.main.borderColor} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
        <h1 className={`m-1 ${themeStyles.main.textHeadingColor}`}>Fleet General Settings</h1>
        <div>
          <FleetGeneralSettings />
        </div>
      </div>
    </div>
  )
}
